module.exports = __webpack_public_path__ + "static/am-ende-der-hoffnuglosigkeit-03-bf2e857f2d818a48d15798fbc21d4ba2.jpg";